import React from 'react'
import clsx from 'clsx'
import { Hierarchy, MessageText } from 'iconsax-react'
import { Skeleton, useTheme } from '@mui/material'

import useBaseStyles from '../TaskCard/styles'
import useTitleStyles from '../TaskCard/Title/styles'
import useDetailStyles from '../TaskCard/Details/styles'
import useStyles from './styles'

const LoadingTaskCard: React.FC = () => {
  const theme = useTheme()

  const baseClasses = useBaseStyles()
  const titleClasses = useTitleStyles()
  const detailClasses = useDetailStyles()
  const classes = useStyles()

  return (
    <div className={clsx(baseClasses.root, classes.root)}>
      <div className={titleClasses.root}>
        <Skeleton width={100} />
      </div>

      <div className={detailClasses.root}>
        <div className={detailClasses.count} style={{ marginRight: '10px' }}>
          <span className='count'>-</span>

          <span className='icon'>
            <Hierarchy size={theme.size.sm} className={detailClasses.icon} />
          </span>
        </div>

        <div className={detailClasses.count}>
          <span className='count'>-</span>

          <span className='icon'>
            <MessageText size={theme.size.sm} />
          </span>
        </div>
      </div>
    </div>
  )
}

export default LoadingTaskCard
